import { useBoxLead } from "@modules/boxLead/hooks/useBoxLeadDetails"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"

type BoxLeadDetailsHeaderProps = {
  leadId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadDetailsHeader({ leadId, ...props }: BoxLeadDetailsHeaderProps) {
  const { data: leadDetails, isLoading } = useBoxLead(leadId)

  return (
    <HuAvatarCardSidebar
      id={leadDetails.user?.id}
      avatar={leadDetails.user?.avatar}
      firstname={leadDetails.user?.firstname ?? leadDetails.firstname ?? ""}
      lastname={leadDetails.user?.lastname ?? leadDetails.lastname ?? ""}
      username={leadDetails.getUserName()}
      email={leadDetails.email ?? undefined}
      canUseContact={leadDetails.user ? true : false}
      isLoading={isLoading}
      {...props}
    />
  )
}
